import React from "react";
import { CheckIcon, ShieldCheckIcon, ZapIcon, InfinityIcon, CreditCardIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { images } from "../../data/links";
const getItems = ["6 specialized clinical blueprints", "Visual decision-making frameworks", "Practical review checklists", "Treatment planning worksheets", "5 exclusive professional bonuses"];
const trust = [{
  icon: ZapIcon,
  label: "Instant digital access"
}, {
  icon: CreditCardIcon,
  label: "One-time payment"
}, {
  icon: InfinityIcon,
  label: "Lifetime access"
}, {
  icon: ShieldCheckIcon,
  label: "7-day guarantee"
}];
export function HeroSection() {
  return <header className="relative bg-ink" data-id="element-198" data-mp="1dks2d1ic7gh7">
      <div className="bg-brand px-4 py-2.5 text-center text-[13px] font-extrabold uppercase text-ink sm:text-sm" data-id="element-199" data-mp="1dltc92nm9wxc">
        The clinical planning system for clear aligner professionals
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 pb-14 pt-8 sm:pt-14 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-20" data-id="element-200" data-mp="14l4zeb9ym2m1">
        <div className="text-center lg:text-left" data-id="element-201" data-mp="31mt7f5ral04m">
          <p className="font-display text-lg font-extrabold text-brand sm:text-xl" data-id="element-202" data-mp="36f49of9i8y0c">THE CLINCHECK BLUEPRINT™</p>
          <h1 className="mt-3 text-balance font-display text-[34px] font-extrabold leading-[1.08] text-white sm:text-5xl lg:text-[56px]" data-id="element-203" data-mp="2soh9sjs0d22o">
            Review Your Next ClinCheck in <span className="text-brand" data-id="element-204" data-mp="3kevky88n00an">10 Minutes or Less</span>
          </h1>
          <p className="mt-4 text-lg font-semibold text-white/90 sm:text-xl" data-id="element-205" data-mp="3kcswvtr1oh8k">
            With a Structured Clinical Review System
          </p>

          <img src={images.hero} alt="The ClinCheck Blueprint 6-volume collection with 5 bonus resources" className="mx-auto mt-6 w-full max-w-lg lg:hidden" data-id="element-206" data-mp="3bcw1zae2am52" />

          <p className="mt-6 text-2xl font-extrabold text-gold" data-id="element-207" data-mp="1zxr0g9po2tn1">Stop second-guessing your clear aligner treatment plans.</p>
          <p className="mt-4 text-lg leading-relaxed text-white/75" data-id="element-208" data-mp="24z6kbyg3yu3u">
            A practical, step-by-step clinical review system to help you evaluate ClinCheck setups more systematically,
            identify potential concerns before approval, and approach treatment planning with greater confidence.
          </p>

          <ul className="mx-auto mt-6 grid max-w-md gap-2.5 text-left lg:mx-0" data-id="element-209" data-mp="ph6nevfjzoz">
            {getItems.map(item => <li key={item} className="flex items-center gap-3 text-[17px] font-semibold text-white" data-id="element-210" data-mp="3nw9vd3mopxp3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-211" data-mp="3iwx7qgnzomlg">
                  <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-212" data-mp="3dxu1isw9wabw" />
                </span>
                {item}
              </li>)}
          </ul>

          <div className="mt-8 lg:max-w-xl" data-id="element-213" data-mp="1c6qoxy2tolop">
            <p className="mb-3 text-center text-lg font-bold text-white lg:text-left" data-id="element-214" data-mp="1c6gzcblowgjj">
              Today: <span className="text-white/50 line-through" data-id="element-215" data-mp="185x1f5tal8wc">$264</span>{" "}
              <span className="text-3xl font-black text-cta" data-id="element-216" data-mp="2q3torabw8q6p">Just $27 USD</span>
            </p>
            <CTAButton id="first-cta" label="Get the ClinCheck Blueprint™" sublabel="Instant download · No subscriptions" data-id="element-217" data-mp="2v1bpidfrbz3m" />
          </div>

          <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-3 text-left sm:flex sm:flex-wrap sm:justify-center lg:justify-start" data-id="element-218" data-mp="2ztmzk947p19w">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-[13px] font-semibold text-white/80" data-id="element-219" data-mp="275quag0ku11i">
                <Icon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-220" data-mp="2c3sljo85p6o2" />
                {label}
              </li>)}
          </ul>

          <p className="mt-6 text-sm text-white/60" data-id="element-221" data-mp="2l4gsy031o8rz">
            Created by <span className="font-bold text-white" data-id="element-222" data-mp="2l1kt267mza0w">Dr. Nathan Brooks</span> for dental professionals.
          </p>
        </div>

        <img src={images.hero} alt="The ClinCheck Blueprint 6-volume collection with 5 bonus resources" className="hidden w-full lg:block" data-id="element-223" data-mp="dgdtx83txcx" />
      </div>
    </header>;
}